import React, { useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

function Search() {
  const { user } = useAuth();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const timerRef = useRef(null);

  const handleSearch = (value) => {
    setQuery(value);
    clearTimeout(timerRef.current);
    if (value.length < 3) { setResults([]); return; }
    timerRef.current = setTimeout(async () => {
      setSearching(true);
      const data = await api.searchBooking(value);
      if (data && data.bookings) setResults(data.bookings);
      setSearching(false);
    }, 400);
  };

  return (
    <div className="animate-in">
      {/* Search Input */}
      <div style={{ position: 'relative', marginBottom: '16px' }}>
        <span style={{ position: 'absolute', left: '14px', top: '14px', fontSize: '16px' }}>🔍</span>
        <input
          type="text"
          value={query}
          onChange={e => handleSearch(e.target.value)}
          placeholder="Référence GYG ou nom du client..."
          style={{
            width: '100%', padding: '14px 14px 14px 44px', background: '#1a1a1a',
            border: '2px solid #333', borderRadius: '14px', color: 'white',
            fontSize: '16px', outline: 'none'
          }}
          autoFocus
        />
      </div>

      {/* Results */}
      {searching && (
        <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>
      )}

      {!searching && results.length === 0 && query.length >= 3 && (
        <div style={{ background: '#1a1a1a', borderRadius: '14px', padding: '30px', textAlign: 'center', border: '1px solid #333' }}>
          <div style={{ fontSize: '30px', marginBottom: '8px' }}>🔎</div>
          <div style={{ color: '#888' }}>Aucun résultat pour "{query}"</div>
        </div>
      )}

      {results.map(b => (
        <div key={b.id} className="animate-in" style={{
          background: '#1a1a1a', borderRadius: '14px', padding: '16px',
          marginBottom: '10px', border: '1px solid #333'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: '15px' }}>{b.first_name} {b.surname}</div>
              <div style={{ fontSize: '12px', color: '#E53E3E', fontWeight: 500 }}>{b.reference}</div>
            </div>
            <div style={{ background: '#1E3A5F', color: '#60A5FA', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>
              {b.participants}P
            </div>
          </div>

          <div style={{ marginTop: '12px', fontSize: '13px', color: '#ccc', lineHeight: '1.8' }}>
            <div>📅 {b.group_date} · 🕐 {b.group_time?.substring(0, 5)}</div>
            <div>📍 {b.group_pickup || b.pickup_point}</div>
            <div>🗣 {b.language} · 👤 Guide: <strong style={{ color: b.guide_name ? '#10B981' : '#F59E0B' }}>{b.guide_name || 'Non assigné'}</strong></div>
            {b.notes && <div>📝 {b.notes}</div>}
            {user.role === 'admin' && b.email && b.email !== '***' && (
              <>
                <div>📧 {b.email}</div>
                <div>📞 {b.phone}</div>
              </>
            )}
          </div>

          {/* Action buttons - admin only for contact */}
          {user.role === 'admin' && b.phone && b.phone !== '***' && (
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <a href={`https://wa.me/${b.phone.replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer"
                style={{
                  flex: 1, background: '#25D366', color: 'white', border: 'none', borderRadius: '10px',
                  padding: '10px', textAlign: 'center', fontWeight: 600, fontSize: '13px', textDecoration: 'none'
                }}>
                WhatsApp
              </a>
              <a href={`mailto:${b.email}`}
                style={{
                  flex: 1, background: '#2a2a2a', color: 'white', border: '1px solid #444', borderRadius: '10px',
                  padding: '10px', textAlign: 'center', fontWeight: 600, fontSize: '13px', textDecoration: 'none'
                }}>
                Email
              </a>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default Search;
